import { OverlayTrigger, Tooltip } from "react-bootstrap";

const OT = Object.assign(OverlayTrigger);
export const InfoTooltip = ({ message, placement = "right" }) => (
  <OT overlay={<Tooltip>{message}</Tooltip>} placement={placement}>
    <i className="bi bi-info-circle text-secondary mx-2 opacity-75" />
  </OT>
);
